// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+huoT","image":"styles_image__xuOpM","cards":"styles_cards__5MW1I","card":"styles_card__8k65U"};